import { createContext, useContext } from 'react';

import { UseMutationResult } from '@tanstack/react-query';

import { VenueCreateInviteInputV2 } from '../../../../graphql/API';
import { Action, State } from './types';

export enum Step {
  OfferSelection,
  DateSelection,
  Summary,
  Success,
}

type CreateInviteContextProps = {
  state: State;
  dispatch: React.Dispatch<Action>;

  mutation: UseMutationResult<unknown, unknown, VenueCreateInviteInputV2>;
  submitForm: () => void;
};

export const CreateInviteContext = createContext<CreateInviteContextProps>(
  {} as CreateInviteContextProps,
);

export const useCreateInvite = () => useContext(CreateInviteContext);
